import {YogaNodeProps} from '@wonderlandengine/react-ui';
import {
    Container,
    Image,
    MaterialContext,
    Panel,
} from '@wonderlandengine/react-ui/components';
import React, {useContext} from 'react';
import {UiTexturesManager} from './ui-textures-manager.js';

export const MenuBackground = (props: React.PropsWithChildren<YogaNodeProps>) => {
    const backgrounds = [
        UiTexturesManager.instance.uiBgArctic,
        UiTexturesManager.instance.uiBgCandyland,
        UiTexturesManager.instance.uiBgDesert,
        UiTexturesManager.instance.uiBgForest,
        UiTexturesManager.instance.uiBgIsland,
        UiTexturesManager.instance.uiBgMoon,
        UiTexturesManager.instance.uiBgSwamp,
        UiTexturesManager.instance.uiBgWuk,
    ];
    const randomBackground = backgrounds[Math.floor(Math.random() * backgrounds.length)];
    const mat = useContext(MaterialContext);

    return (
        <Container {...props}>
            <Panel material={mat.panelMaterial!} width={510} height={510} rounding={0}>
                <Image
                    margin={5}
                    rounding={0}
                    src={randomBackground}
                    width={500}
                    height={500}
                />
                <Container top={-500}>{props.children}</Container>
            </Panel>
        </Container>
    );
};
